export default () => {
	
	console.log(`%c ERA `, 'font-weight: bold; color: white; background: red;')

}
